const NATIVE_CODE_RE = /\[native code\]/;
const COMPAT_STATE_KEY = "__ONLAND_WEBXR_EMULATOR_COMPAT__";

function isNativeCodeFunction(value) {
  return typeof value === "function" && NATIVE_CODE_RE.test(String(value));
}

function setGlobalXRWebGLBinding(globalScope, value) {
  try {
    globalScope.XRWebGLBinding = value;
  } catch (_error) {
    Object.defineProperty(globalScope, "XRWebGLBinding", {
      configurable: true,
      writable: true,
      value
    });
  }
}

function getCompatState(globalScope) {
  if (!globalScope[COMPAT_STATE_KEY]) {
    globalScope[COMPAT_STATE_KEY] = {
      disabledNativeXRWebGLBinding: false,
      originalXRWebGLBinding: undefined
    };
  }

  return globalScope[COMPAT_STATE_KEY];
}

export function isPolyfilledXRSession({ XRSession } = {}) {
  return typeof XRSession === "function" && !isNativeCodeFunction(XRSession);
}

export function shouldDisableNativeXRWebGLBindingForPolyfilledSession({ XRSession, XRWebGLBinding } = {}) {
  return isPolyfilledXRSession({ XRSession }) && isNativeCodeFunction(XRWebGLBinding);
}

export function getWebXRConfigWithoutLayers(webxrConfig = {}) {
  const optionalFeatures = Array.isArray(webxrConfig.optionalFeatures) ? webxrConfig.optionalFeatures : [];

  return {
    ...webxrConfig,
    optionalFeatures: optionalFeatures.filter(feature => feature !== "layers")
  };
}

export function applyWebXREmulatorCompat(globalScope = globalThis) {
  const state = getCompatState(globalScope);
  const shouldDisable = shouldDisableNativeXRWebGLBindingForPolyfilledSession(globalScope);

  if (shouldDisable) {
    if (!state.originalXRWebGLBinding) {
      state.originalXRWebGLBinding = globalScope.XRWebGLBinding;
    }

    setGlobalXRWebGLBinding(globalScope, undefined);
    state.disabledNativeXRWebGLBinding = true;
  } else if (state.disabledNativeXRWebGLBinding && state.originalXRWebGLBinding) {
    setGlobalXRWebGLBinding(globalScope, state.originalXRWebGLBinding);
    state.disabledNativeXRWebGLBinding = false;
  }

  return {
    disabledNativeXRWebGLBinding: state.disabledNativeXRWebGLBinding,
    originalXRWebGLBinding: state.originalXRWebGLBinding
  };
}
